import { useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  OutlinedInput,
  Typography,
} from "@material-ui/core";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";

export default function FormSolicitacaoDialog({
  type,
  open,
  onClose,
  solicitacao,
  handleSearch,
}) {
  const [submitting, setSubmitting] = useState(false);
  const [justificativa, setJustificativa] = useState("");

  const snackbar = useSnackbar();


  const submit = async () => {
    setSubmitting(true);
    console.log("solicitacao", solicitacao);
    const body = {
      idSolicitacao: solicitacao.IdSolicitacao,
      statusSolicitacao: type === "accept" ? "APROVADA" : "REJEITADA",
      ...(type === "reject" && { justificativa: justificativa }),
    };

    await Api.put("edit-request-reason", "trocasDevolucoes", body, true)
      .then((res) => {
        if (res.Success) {
          snackbar.showMessage(
            `Alteração ${
              type === "accept" ? "Aprovada" : "Rejeidata"
            } com sucesso!`,
            {
              severity: "success",
            }
          );
          handleSearch();
          onClose();
        }
      })
      .catch((e) => {
        snackbar.showMessage(e, {
          severity: "error",
        });
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      maxWidth={"md"}
    >
      <DialogTitle>
        <Typography variant="h3">
          {type === "accept" ? "Aprovar Solicitação" : "Recusar Solicitação"}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h4" style={{ marginBottom: "1rem" }}>
          Tem certeza que deseja {type === "accept" ? "aprovar" : "recusar"}{" "}
          essa solicitação?
        </Typography>
        {type === "reject" && (
          <Box>
            <Typography variant="h5" style={{ marginBottom: "0.5rem" }}>
              Justificativa:
            </Typography>
            <Box position="relative">
              <OutlinedInput
                fullWidth
                multiline
                rows={4}
                value={justificativa}
                onChange={e => setJustificativa(e.target.value)}
                placeholder="Digite a justificativa para a recusa da solicitação"
                disabled={submitting}
                style={{ marginBottom: "1rem" }}
                inputProps={{ maxLength: 1000 }}
              />
              <Typography
                variant="caption"
                color="textPrimary"
                style={{
                  position: "absolute",
                  right: 0,
                  bottom: 10,
                  marginRight: "0.5rem",
                  marginBottom: "0.5rem",
                  fontSize: "0.75rem"
                }}
              >
                {justificativa.length}/1000
              </Typography>
            </Box>
          </Box>
        )}
      </DialogContent>
      <DialogActions>
        <Button component={Box} onClick={onClose} disabled={submitting}>
          Cancelar
        </Button>
        <Button
          color="default"
          variant="contained"
          type="submit"
          disabled={submitting || (type === "reject" && !justificativa)}
          onClick={submit}
        >
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
